
export interface IProductFeature {
  included: boolean;
  text: string;
}

export interface IProductCard {
  title: string;
  description: string;
  icon: string;
  url?: string;
  imageUrl?: string;
  features?: IProductFeature[];
  compact?: boolean;
  color?: string;
}

export interface IClassOfBusiness {
  name: string;
  id: any;
  createdAt: string;
  updatedAt: string;
}

export interface IClassOfBusinessQueryParams {
  partnerId?: number | null;
  intermediaryId?: number | null;
  insurerId?: number | null;
}

export interface IBusinessCategoryStyle {
  color: string;
  icon: string;
  features: IProductFeature[];
}

export const classOfBusinessCategoryStyle: Map<string, IBusinessCategoryStyle> =
  new Map([
    [
      'Motor',
      {
        color: '#13c2c2',
        icon: 'car',
        features: [
          { included: true, text: 'Third Party' },
          { included: true, text: 'Comprehensive' },
          { included: true, text: 'Fire and Theft' },
          { included: true, text: 'Act only' },
        ],
      },
    ],
    [
      'Fire',
      {
        color: '#fa8c16',
        icon: 'question-circle',
        features: [
          { included: true, text: 'Fire and Allied Perils' },
          { included: true, text: 'Burglary' },
          { included: true, text: 'Business Interruption' },
          { included: true, text: 'All Risks' },
        ],
      },
    ],
    [
      'Accident',
      {
        color: '#f5222d',
        icon: 'question-circle',
        features: [
          { included: true, text: 'Personal Accident' },
          { included: true, text: 'Workmen Compensation' },
          { included: true, text: 'Public Liability' },
          { included: true, text: 'Product Liability' },
        ],
      },
    ],
    [
      'Marine',
      {
        color: '#1890ff',
        icon: 'compass',
        features: [
          { included: true, text: 'Marine Cargo' },
          { included: true, text: 'Marine Hull' },
          { included: true, text: 'Marine Liability' },
        ],
      },
    ],
    [
      'Engineering',
      {
        color: '#8c8c8c',
        icon: 'tool',
        features: [
          { included: true, text: 'Contractors All Risk' },
          { included: true, text: 'Erection All Risk' },
          { included: true, text: 'Machinery Breakdown' },
          { included: true, text: 'Electronic Equipment' },
        ],
      },
    ],
    [
      'Liability',
      {
        color: '#722ed1',
        icon: 'balance',
        features: [
          { included: true, text: 'Public Liability' },
          { included: true, text: 'Product Liability' },
          { included: true, text: 'Professional Indemnity' },
        ],
      },
    ],
    [
      'MicroInsurance',
      {
        color: '#52c41a',
        icon: 'question-circle',
        features: [
          { included: true, text: 'Micro Health' },
          { included: true, text: 'Micro Life' },
          { included: true, text: 'Micro Agriculture' },
          { included: true, text: 'Micro Property' },
        ],
      },
    ],
    [
      'Bonds And Guaranties',
      {
        color: '#faad14',
        icon: 'handshake',
        features: [
          { included: true, text: 'Bid Bond' },
          { included: true, text: 'Performance Bond' },
          { included: true, text: 'Advance Payment Bond' },
          { included: true, text: 'Retention Bond' },
        ],
      },
    ],
    [
      'Travel',
      {
        color: '#2f54eb',
        icon: 'global',
        features: [
          { included: true, text: 'Travel Medical' },
          { included: true, text: 'Trip Cancellation' },
          { included: true, text: 'Baggage Loss' },
          { included: true, text: 'Flight Delay' },
        ],
      },
    ],
  ]);
